import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-sm navbar-dark bg-dark" }
const _hoisted_2 = { class: "container-fluid justify-content-end" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/momo.jpg",
  style: {"margin-right":"15px","height":"57px"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Пельменная №2")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarNavAltMarkup",
  "aria-controls": "navbarNavAltMarkup",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_6 = {
  class: "collapse navbar-collapse",
  id: "navbarNavAltMarkup"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "navbar-nav me-auto" }, null, -1)
const _hoisted_8 = { class: "navbar-nav align-items-stretch align-items-sm-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CartIcon = _resolveComponent("CartIcon")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "navbar-brand me-auto",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_CartIcon, { class: "d-none d-sm-block" })
        ])
      ]),
      _createVNode(_component_CartIcon, { class: "d-block d-sm-none ms-3" })
    ])
  ]))
}